import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { siteSpecificData } from '../../../environments/site-specific-data'
import { Observable } from 'rxjs';
import { UserPreferencesData } from '../models/user-preferences-data';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@feature/store/application-store';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class UserPreferencesHttpService {

  constructor(
    protected store: Store<ApplicationState>,
    private http: HttpClient) { }

  getUserPreferences(): Observable<UserPreferencesData> {
    let url = `${API_URL}userpreferences`
    return this.http.get<UserPreferencesData>(url)
  }

  getUserPreferencesSystemDefaults(): Observable<UserPreferencesData> {
    let url = `${API_URL}userpreferences/systemdefaults`
    return this.http.get<UserPreferencesData>(url)
  }

  setUserPreferences(request : UserPreferencesData): Observable<any> {
    let url = `${API_URL}userpreferences`
    return this.http.post(url, request)
  }

  getUserPreferenceEffectiveValues(): Observable<UserPreferencesData> {
    let url = `${API_URL}userpreferences/effectivevalues`
    return this.http.get<UserPreferencesData>(url)
  }

}
